import { Route } from '@angular/router';
import { authGuard } from '../authentication/guards/authGuard';
import { roleGuard } from '../authentication/guards/roleGuard';

export function nullIfEmpty(value: string | null | undefined): string | null {
  return value === null || value === undefined || value === '' ? null : value;
}

export function booleanToString(value: boolean | null): string | undefined {
  if (value === true) {
    return 'true';
  } else if (value === false) {
    return 'false';
  } else {
    return undefined;
  }
}
export function getBooleanValue(value: boolean | string | null | undefined): boolean | null {
  if (value === true || value === 'true') {
    return true;
  }

  if (value === false || value === 'false') {
    return false;
  }

  return null;
}
export function secureRoute(route: Omit<Route, 'canActivate'>): Route {
  return {
    ...route,
    canActivate: [authGuard, roleGuard],
    data: {
      roles: ['mhs.scmmanager.user'],
      ...route.data,
    },
  };
}
